'use strict';

import register from './core';
import '../functions/jquery-global.js';
import Handlebars from 'handlebars/dist/handlebars';

var active = null;
var selectedItem = null;
var currX = 0;
var currY = 0;

register('menu-init', function (element) {
  var findAncestor = function (el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
  };

  var items = element.getElementsByClassName('navigation__link--active');
  for (var i = 0; i < items.length; i++) {
    var parent = findAncestor(items[i], 'navigation__submenu');

    if (parent) {
      parent.setAttribute('aria-expanded', 'true');
    }
  };
});

register('menu-toggle', function (element) {
  var menuId = element.getAttribute('aria-controls');
  if (!menuId) {
    return;
  }

  var menu = document.getElementById(menuId);
  if (!menu) {
    return;
  }

  var body = document.getElementsByTagName('body')[0],
    disableScrollClass = 'disable-scroll';

  element.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (active && active.menu !== menu) {
      element.menu.setAttribute('aria-expanded', 'false');
      active.menu.setAttribute('aria-expanded', 'false');
      active.button.removeAttribute('data-expanded');
      body.classList.remove(disableScrollClass);
    }

    var expanded = menu.getAttribute('aria-expanded');
    if (expanded === 'true') {
      element.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-expanded', 'false');
      element.removeAttribute('data-expanded');
      body.classList.remove(disableScrollClass);

      active = null;
    }
    else {
      element.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-expanded', 'true');
      element.setAttribute('data-expanded', '');
      body.classList.add(disableScrollClass);

      active = {
        menu: menu,
        button: element
      };
    }
  });
});

register('menu-browse', function (element) {
  var menuId = element.getAttribute('aria-controls');
  if (!menuId) {
    return;
  }

  var menu = document.getElementById(menuId);
  if (!menu) {
    return;
  }

  element.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    var expanded = menu.getAttribute('aria-expanded');
    if (expanded === 'true') {
      element.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-expanded', 'false');
      selectedItem = null;
    } else {
      element.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-expanded', 'true');
      selectedItem = {
        menu: menu
      };
    }
  });
});

register('navigation-preview', function (element) {
  let currentLang = $('html').attr('lang');
  var startNodeId = element.getAttribute('data-start-node');

  let previewTemplate = Handlebars.compile($('#template-preview').html());
  let $previewContainer = $(".dropdown__items .page-preview-container", $(element));
  var mainNodeContainer = [];
  if (!startNodeId) {

    return;
  }
  if ($previewContainer.length == 0) {

    return;
  }

  const cachedMainNodes = {};
  const cachedImages = {};

  $.ajax({
    url: '/api/pagepreviewapi/getpagepreviewsasync',
    dataType: 'json',
    headers: {
      'X-Language': currentLang
    },
    data: {
      StartNodeId: startNodeId
    }
  }).done(function (data) {

    mainNodeContainer = data;
    cacheMainNodes(mainNodeContainer);
    initNavigationPagePreview();
    initNavigationCaching();
  });

  function initNavigationPagePreview() {
    $(".preview__item").on('focus mouseover', showPagePreview);
    $(".preview__item").on('mouseleave blur', clearPagePreview);
  }

  function initNavigationCaching() {
    $(".dropdown__button").on('click', cacheCurrentMenuSubNodes);
    $(document).on('click','TriggerPath' ,cacheCurrentMenuSubNodes);
  }

  function cacheMainNodes(data) {
    data.forEach(function (item) {
      if (item.ImageUrl) {
        if (!cachedMainNodes[item.ImageUrl]) {
          const img = new Image();
          img.src = item.ImageUrl;
          cachedMainNodes[item.ImageUrl] = img;
        }
        if (!cachedImages[item.ImageUrl]) {
          const img = new Image();
          img.src = item.ImageUrl;
          cachedImages[item.ImageUrl] = img;
        }
      }
    });
  }

  function cacheCurrentMenuSubNodes(e) {
    const $this = $(e.currentTarget);
    const pageId = $this.attr("data-contentlink-id");
    const parsedPageId = parseInt(pageId, 10);

    if (fetchStatus[parsedPageId]) {
      return;
    };

    if (pageId) {

      for (const node of mainNodeContainer) {
        if (node.ContentReferenceId === parsedPageId) {
          getNodes(node.ContentReferenceId);
          fetchStatus[parsedPageId] = true;
        }
      }
    }
  }

  var subNodesContainer = [];
  const fetchStatus = {};
  function getNodes(pageId) {

    $.ajax({
      url: '/api/pagepreviewapi/getpagepreviewsasync',
      dataType: 'json',
      headers: {
        'X-Language': currentLang
      },
      data: {
        StartNodeId: pageId
      }
    }).done(function (data) {
      subNodesContainer = subNodesContainer.concat(data);
      cacheSubNodeImages(subNodesContainer);
    });
  }

  function cacheSubNodeImages(data) {
    data.forEach(function (item) {
      if (item.ImageUrl) {
        if (!cachedImages[item.ImageUrl]) {
          const img = new Image();
          img.src = item.ImageUrl;
          cachedImages[item.ImageUrl] = img;
        }
      }
    });
  }

  function showPagePreview(e) {
    const $this = $(e.target);
    const pageId = $this.attr("data-contentlink-id");

    if (pageId == undefined) { 
      return;
    }

    currX = e.clientX;
    currY = e.clientY;

    $previewContainer.removeClass('page-preview-container--open');

    setTimeout(() => {

      var x = e.clientX;
      var y = e.clientY;

      if (x == currX && y == currY) {
        const mainHit = mainNodeContainer.filter(page => page.ContentReferenceId == pageId)[0];

        if (mainHit != undefined) {
          $previewContainer.html(previewTemplate(mainHit));
          $previewContainer.addClass('page-preview-container--open');

          if (mainHit.ImageUrl && cachedImages[mainHit.ImageUrl]) {
            $previewContainer.find('.preview-img').attr('src', cachedImages[mainHit.ImageUrl].src);
          }
        }

        const subHit = subNodesContainer.filter(page => page.ContentReferenceId == pageId)[0];

        if (subHit != undefined) {
          $previewContainer.html(previewTemplate(subHit));
          $previewContainer.addClass('page-preview-container--open');

          if (subHit.ImageUrl && cachedImages[subHit.ImageUrl]) {
            $previewContainer.find('.preview-img').attr('src', cachedImages[subHit.ImageUrl].src);
          }
        }
      }
    }, 350);

  }

  function clearPagePreview(e) {
    setTimeout(() => {
      $previewContainer.removeClass('page-preview-container--open');
      $previewContainer.empty();
    }, 200); 
  }
})
